import React, { FunctionComponent, useEffect, useState } from 'react'
import { List } from 'antd'
import { useParams } from 'react-router'
import { BrokersService } from '../api/services.gen'
import { BrokerDto, OptionDto } from '../api'

type BrokerAssetParams = { broker: string, asset: string }

interface BrokerAssetPageProps {}

export const BrokerAssetPage: FunctionComponent<BrokerAssetPageProps> = ({ }) => {
  const params = useParams<BrokerAssetParams>()
  const [broker, setBroker] = useState<BrokerDto | null>(null)
  const [options, setOptions] = useState<OptionDto[]>([])

  const fetchBroker = async () => {
    const response = await BrokersService.getBroker({ broker: params.broker! })
    setBroker(response.broker)
  }

  const fetchOptions = async () => {
    const response = await BrokersService.getBrokerOptions({ broker: params.broker!, asset: params.asset! })
    setOptions(response.options)
  }

  useEffect(() => {
    fetchBroker()
    fetchOptions()
  }, [params.broker, params.asset])

  return <>
    <h2>Broker {params.broker} asset {params.asset}</h2>
    <div>
      <h3>Options</h3>
      <List>
        {
          options.map(option => <List.Item>
            <List.Item.Meta title="Symbol" description={option.symbol} />
            <List.Item.Meta title="Size" description={option.size} />
            <List.Item.Meta title="Type" description={String(option.meta?.type)} />
            <List.Item.Meta title="Strike" description={String(option.meta?.strikePrice)} />
            <List.Item.Meta title="Expire" description={typeof option.meta?.expiration === 'string' ? option.meta.expiration.split('T')[0] : ''} />
          </List.Item>)
        }
      </List>
    </div>
  </>
}